import Vue from 'vue'
import constants from './constants'
import hcpFormat from '@/library/hcpFormat'

let clone = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

const mutations = {
  setActiveBetSlipHistoryTab (state, tab) {
    // !!! USED BY EXTERNAL COMPONENT !!!
    let tab2 = state.historyTabs.indexOf(tab) >= 0 ? tab : ''
    Vue.set(state, 'historyTab', tab2)
  },
  setCloseFromParent (state, val) {
    // !!! USED BY EXTERNAL COMPONENT !!!
    Vue.set(state, 'closeFromParent', val)
  },
  setActiveBetSlip (state, id) {
    // !!! USED BY EXTERNAL COMPONENT !!!
    Vue.set(state, 'activeBetSlip', id)
  },

  setAddingMiltipleSelections (state, val) {
    Vue.set(state.addingMiltipleSelections, 'inProgress', val)
  },

  // Betting Params - Core
  setBPCisFOPreferredInSingles (state, val) {
    if (typeof val === 'string') {
      val = val.trim()
      val = val.toLowerCase()
    }
    val = JSON.parse(val)
    window.ctsautoconf = window.ctsautoconf || {}
    if (window.ctsautoconf.BETSLIP) {
      window.ctsautoconf.BETSLIP.isFOPreferredInSingles = val
    }
    Vue.set(state, 'isFOPreferredInSingles', val)
  },
  setBPCisFPPreferredInMultiples (state, val) {
    // console.log('setBPCisFPPreferredInMultiples')
    if (typeof val === 'string') {
      val = val.trim()
      val = val.toLowerCase()
    }
    val = JSON.parse(val)
    window.ctsautoconf = window.ctsautoconf || {}
    if (window.ctsautoconf.BETSLIP) {
      window.ctsautoconf.BETSLIP.isFPPreferredInMultiples = val
    }
    Vue.set(state, 'isFPPreferredInMultiples', val)
  },

  // Betting Params - BetSlip
  setMultiSinglesStake (state, val) {
    Vue.set(state, 'multiSinglesStake', val)
  },
  setUnitStakeMin (state, val) {
    Vue.set(state, 'unitStakeMin', val)
    Vue.set(state.stakeLimits.min, 'PerSelection', val)
    // Vue.set(state.stakeLimits.min, 'PerBetType', val)
  },
  setMultiStakeMinUnit (state, val) {
    Vue.set(state.stakeLimits.min, 'PerBetType', val)
  },
  setUnitStakeMax (state, val) {
    Vue.set(state, 'unitStakeMax', val)
    Vue.set(state.stakeLimits.max, 'PerSelection', val)
    Vue.set(state.stakeLimits.max, 'PerBetType', val)
  },
  setSlipTotalStakeMax (state, val) {
    Vue.set(state, 'slipTotalStakeMax', val)
  },
  setSlipTotalStakeMaxInPlay (state, val) {
    Vue.set(state, 'slipTotalStakeMaxInPlay', val)
  },
  setMaxPotentialSlipPayout (state, val) {
    Vue.set(state, 'maxPotentialSlipPayout', val)
  },
  setSlipTotalStakeMin (state, val) {
    Vue.set(state, 'slipTotalStakeMin', val)
  },
  setUnitStakeIncrement (state, val) {
    Vue.set(state, 'unitStakeIncrement', val)
  },
  setStakeMaxUnit (state, val) {
    Vue.set(state, 'stakeMaxUnit', val)
  },
  setTotalBetSlipMinUnit (state, val) {
    Vue.set(state, 'totalBetSlipMinUnit', val)
  },

  getConfig (state) {
    // console.log('BetSlip getCongig')
    let storeData = function (obj, path) {
      path = path || []
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          if (typeof obj[i] === 'object' && obj[i] !== null && !Array.isArray(obj[i])) {
            storeData(obj[i], path.concat(i))
          } else {
            var target = state
            if (path.length) {
              path.forEach(function (k) {
                if (!target[k]) {
                  Vue.set(target, k, {})
                }
                target = target[k]
              })
            }
            // console.log(path.concat(i).join('.') + ': ' + obj[i])
            Vue.set(target, i, obj[i])
          }
        }
      }
    }
    //
    var data = (window.ctsautoconf && window.ctsautoconf.BETSLIP) || {}
    storeData(data)
    // console.log('state:')
    // console.log(JSON.stringify(state))
  },
  getConfigToState (state) {
    // console.log('BetSlip getCongig')
    var data = window.ctsautoconf.BETSLIP
    for (var i in data) {
      Vue.set(state, i, data[i])
    }
  },
  setTab (state, id) {
    Vue.set(state, 'tab', id)
  },
  setMobileTab (state, id) {
    // console.log('setMobileTab:', id)
    Vue.set(state, 'mobileTab', id)
  },
  setPriceType (state, selection) {
    // console.log('setPriceType')
    let csvpricetypes = (selection.csvpricetypes || []).filter(pt => pt !== 'SGM')
    let priceType = csvpricetypes[0] || 'CP'
    let priceTypePerBetType = {S: priceType, Multi: priceType}
    //
    if (csvpricetypes && csvpricetypes.includes('CP')) {
      priceType = 'CP'
      priceTypePerBetType.S = priceType
      priceTypePerBetType.Multi = priceType
    }
    //
    if (state.isFPPreferredInMultiples && csvpricetypes && csvpricetypes.includes('FP')) {
      priceType = 'FP'
      priceTypePerBetType.Multi = priceType
    }
    //
    if (csvpricetypes && csvpricetypes.includes('XP') && ((selection.estimatepriceup && selection.estimatepricedown) ||
      (!csvpricetypes.includes('CP') && selection.isInjectedFrom3rdParty))) {
      priceType = 'XP'
      priceTypePerBetType.S = priceType
      priceTypePerBetType.Multi = priceType
    }
    //
    Vue.set(selection, 'pricetype', priceType)
    Vue.set(selection, 'priceTypePerBetType', priceTypePerBetType)
  },
  clearStakesAndReturns (state) {
    Vue.set(state, 'betTypeStakes', clone(constants.initialBetTypeStakes))
    Vue.set(state, 'returns', clone(constants.initialReturns))
    Vue.set(state, 'multiSinglesStake', null)
  },
  clearBetSlip (state) {
    // console.log('Mutation clearBetSlip')
    Vue.set(state, 'betslipSelectionsIds', {})
    Vue.set(state, 'betslipSelections', [])
    Vue.set(state, 'betslipSelectionIds', [])
    Vue.set(state, 'markets', {})
    Vue.set(state, 'idfomarkets', {})
    Vue.set(state, 'idfoevents', {})
    Vue.set(state, 'allowedBetTypesAndReturns', clone(constants.initialABTnRperTab))
    Vue.set(state, 'betTypeStakes', clone(constants.initialBetTypeStakes))
    Vue.set(state, 'returns', clone(constants.initialReturns))
    Vue.set(state, 'toggleTime', {})
    Vue.set(state, 'multiSinglesStake', null)
    //
    Vue.set(state, 'tab', 'REGULAR')
    Vue.set(state, 'mobileTab', 'REGULAR')
    Vue.set(state.optedIn, 'REGULAR', {})
    Vue.set(state.optedIn, 'RR', {})
    Vue.set(state.optedIn, 'TEASER', {})
    Vue.set(state.derivatives.teasers, 'T', clone(constants.initialTeasers))
    for (let a in state.derivatives.teasers.activeByGroup) {
      Vue.set(state.derivatives.teasers.activeByGroup, a, '')
    }
    Vue.set(state.derivatives.teasers, 'teaserGroups', [])
    Vue.set(state.derivatives.pitchers, 'derived', {})
    Vue.set(state.derivatives.pitchers, 'sourceMap', {})
    Vue.set(state.derivatives.buyPoints, 'derived', {})
    Vue.set(state.derivatives.buyPoints, 'sourceMap', {})
  },
  killHlite (state) {
    // console.log('killHlite')
    var v = state.clearMarkings
    v += 1
    Vue.set(state, 'clearMarkings', v)
  },

  clearMarkings (state) {
    Vue.set(state, 'clearMarkings', 0)
  },

  resetAllowedBetTypesAndReturns (state) {
    // console.log('resetAllowedBetTypesAndReturns')
    Vue.set(state, 'gettingABTnR', false)
    Vue.set(state, 'allowedBetTypesAndReturns', clone(constants.initialABTnRperTab))
    Vue.set(state.allowedBetTypesAndReturnsRequestData, 'REGULAR', '')
    Vue.set(state.allowedBetTypesAndReturnsRequestData, 'RR', '')
    Vue.set(state.allowedBetTypesAndReturnsRequestData, 'TEASER', {})
  },
  resetAllowedBetTypesAndReturnsRequestData (state) {
    // console.log('resetAllowedBetTypesAndReturnsRequestData')
    Vue.set(state.allowedBetTypesAndReturnsRequestData, 'REGULAR', '')
    Vue.set(state.allowedBetTypesAndReturnsRequestData, 'RR', '')
    // Vue.set(state.allowedBetTypesAndReturnsRequestData, 'TEASER', {})
  },
  resetAllowedBetTypesAndReturnsXP (state) {
    // console.log('resetAllowedBetTypesAndReturnsXP')
    let XPinitial = {
      PerEvent: {},
      BetFairXPBettingProvider: {
        SGP: {
          PerEvent: {}
        }
      }
    }
    Vue.set(state.allowedBetTypesAndReturns, 'XP', XPinitial)
  },
  resetABTnR4Teaser (state, sport) {
    // console.log('resetABTnR4Teaser')
    Vue.set(state.allowedBetTypesAndReturns.TEASER, sport, clone(constants.initialABTnR))
  },
  setActiveTeaser (state, arr) {
    Vue.set(state.derivatives.teasers.activeByGroup, arr[0], arr[1])
  },
  resetActiveTeaser (state) {
    // console.log('resetActiveTeaser')
    for (let a in state.derivatives.teasers.activeByGroup) {
      // console.log(a + ': ' + state.derivatives.teasers.activeByGroup[a])
      var tg = state.derivatives.teasers && state.derivatives.teasers.teaserGroups &&
        state.derivatives.teasers.teaserGroups.find(g => g.idFoSport === a)
      if (!(tg && tg.Selections && tg.Selections.length)) {
        // Vue.set(state.derivatives.teasers.activeByGroup, a, state.config.derivatives.teasers.defaultActiveLevel[a])
        Vue.set(state.derivatives.teasers.activeByGroup, a, '')
      }
    }
  },
  setReInitPitchers (state, val) {
    Vue.set(state.derivatives.pitchers, 'reInit', val)
  },
  setShowAcceptingChangesInfo (state, val) {
    state.showAcceptingChangesInfo = val
  },

  setCurrentBetSlipState (state, id) {
    // console.log('setCurrentBetSlipState:', id)
    Vue.set(state, 'currentBetSlipState', id)
  },
  setAttemptedBetSlip (state, betSlip) {
    Vue.set(state.attemptedBetSlip, 'betSlip', betSlip)
  },
  setAttemptedBetSlipResponse (state, response) {
    Vue.set(state.attemptedBetSlip, 'response', response)
  },
  setAttemptedBetSlipStatus (state, response) {
    Vue.set(state.attemptedBetSlip, 'betSlipStatus', response)
  },
  setInRefferal (state, bool) {
    Vue.set(state.attemptedBetSlip, 'inRefferal', bool)
  },
  dismissErrorFromSelection (state, id) {
    var v = state.dismissErrorFromSelection
    v += 1
    // Vue.set(state, 'dismissErrorFromSelectionId', id)
    Vue.set(state, 'dismissErrorFromSelection', v)
  },
  setRememberSingleBetSlipStake (state, val) {
    // state.fastBetSlip.rememberSingleBetSlipStake = val
    Vue.set(state.fastBetSlip, 'rememberSingleBetSlipStake', val)
    /*
    if (!val) {
      Vue.set(state.fastBetSlip, 'stake', '')
    }
    */
  },
  setSingleBetSlipStake (state, val) {
    // state.fastBetSlip.stake = val
    if (state.fastBetSlip.rememberSingleBetSlipStake) {
      if (val) {
        // console.log('setSingleBetSlipStake: ' + val)
        Vue.set(state.fastBetSlip, 'stake', val)
      }
    } else {
      val = ''
      // console.log('setSingleBetSlipStake: ' + val)
      Vue.set(state.fastBetSlip, 'stake', val)
    }
  },
  resetPromotions (state, tab) {
    // console.log('resetPromotions')
    Vue.set(state.promotionsData, tab, clone(constants.initialPromotions[tab]))
    Vue.set(state.promotionsData.PerTab, tab, 0)
  },
  setSpecialOfferTranslation (state, dataArr) {
    let [valueString, item] = dataArr
    // console.log('setMultiStakeMinUnit:', 'item:', item, 'val:', valueString)
    let parts = item.split('.')
    let id = parts[1]
    let legsToAdd = parts[2]
    let key = 'SpecialOffer.' + id
    if (legsToAdd === '0') {
      key += '.eligible'
    } else {
      key += '.offer.addLeg' + (legsToAdd !== '1' ? 's' : '')
    }
    valueString = valueString.replace('#01', '%{shortDescription}')
    valueString = valueString.replace('#03', '%{legsToAdd}')
    console.log('Add translation:', key, ':', valueString)
    Vue.set(state.config.specialOffers.translations, key, valueString)
  },
  setArePromoVouchersForced (state, v) {
    let arePromoVouchersForced = !!v
    console.log('ArePromoVouchersForced:', v, '=>', arePromoVouchersForced)
    Vue.set(state.config.promotions, 'getApplicableVouchers', !arePromoVouchersForced)
  },
  resetABTnRrequestData (state) {
    // console.log('resetABTnRrequestData')
    Vue.set(state, 'allowedBetTypesAndReturnsRequestData', {
      'REGULAR': '',
      'RR': '',
      'TEASER': {}
    })
  },
  setVoucherRrequestData (state, data) {
    let tab = data.tab
    let betsIdStr = data.betsIdStr
    Vue.set(state.promotions.betsIdStr, tab, betsIdStr)
  },
  resetVoucherRrequestData (state, data) {
    Vue.set(state.promotions, 'betsIdStr', {})
  },
  resetPromotionVouchersApplication (state, tab) {
    // console.log('resetPromotionVouchersApplication')
    let vouchers = state.promotions.vouchers[tab] || []
    for (let voucher of vouchers) {
      Vue.set(voucher, 'appliedTo', null)
    }
  },
  resetAllPromotionVouchersApplication (state) {
    // console.log('resetAllPromotionVouchersApplication')
    Vue.set(state.promotions, 'appliedVoucher', {})
    //
    let vouchers = state.promotions.vouchers || []
    for (let tab in vouchers) {
      for (let voucher of vouchers[tab]) {
        Vue.set(voucher, 'appliedTo', null)
      }
    }
  },
  setPromotionVouchers (state, [vouchers = [], tab, caller]) {
    // console.log('setPromotionVouchers by:', caller, 'from:', JSON.parse(JSON.stringify(state.promotions.vouchers)))
    // console.log('setBonusBetVouchers to:', vouchers)
    if (['onLogIn', 'onLogOut'].includes(caller)) {
      Vue.set(state.promotions.vouchers, 'REGULAR', [])
      Vue.set(state.promotions.vouchers, 'RR', [])
      Vue.set(state.promotions.vouchers, 'TEASER', [])
    } else {
      tab = tab || state.tab
      if (!state.promotions.vouchers[tab]) {
        Vue.set(state.promotions.vouchers, tab, [])
      }
      // console.log('setPromotionVouchers to:', tab, vouchers)
      Vue.set(state.promotions.vouchers, tab, vouchers)
    }
    // console.log('setPromotionVouchers to:', tab, state.promotions.vouchers)
  },
  setAvailableVouchers (state, vouchers) {
    let cv = JSON.stringify(state.promotions.availableVouchers)
    let nv = JSON.stringify(vouchers)
    if (nv !== cv) {
      Vue.set(state.promotions, 'availableVouchers', vouchers)
    }
  },
  resetAvailableVouchers (state, vouchers) {
    Vue.set(state.promotions, 'availableVouchers', [])
  },
  applyVoucher (state, data) {
    let tab = data.tab
    let isBetAvailable = true
    let betId = data.betId
    let voucher = data.voucher
    let voucherId = voucher.IDMMPRVoucher
    let id = voucherId + '|' + betId
    let appliedVoucher = state.promotions.appliedVoucher[tab] || null
    let discount = (appliedVoucher && appliedVoucher.discount) || 0
    let isActive = data.caller || 0
    // console.log('applyVoucher::: voucher:', voucher, 'appliedVoucher:', JSON.stringify(appliedVoucher), (appliedVoucher && appliedVoucher.id))
    if (appliedVoucher && appliedVoucher.id && appliedVoucher.id === id && appliedVoucher.isActive) {
      // voucher = null
      discount = 0
      // voucherId = null
      isBetAvailable = data.caller === true
      // betId = null
      isActive = 0
    }
    Vue.set(state.promotions.appliedVoucher, tab, {id, discount, voucherId, isBetAvailable: isBetAvailable, betId, isActive, voucher})
    // console.log('New appliedVoucher:', JSON.stringify(state.promotions.appliedVoucher))
  },
  clearAppliedVouchers (state) {
    // console.log('clearAppliedVouchers')
    Vue.set(state.promotions, 'appliedVoucher', {})
  },
  clearAppliedVoucher (state, tab) {
    // console.log('clearAppliedVoucher')
    Vue.set(state.promotions.appliedVoucher, tab, {id: null, discount: 0, voucherId: null, isBetAvailable: false, betId: null, isActive: 0})
  },
  clearAppliedVouchersById (state, ids) {
    // console.log('clearAppliedVouchersById:', ids)
    for (let id of ids) {
      for (let tab in state.promotions.appliedVoucher) {
        if (state.promotions.appliedVoucher[tab] &&
          state.promotions.appliedVoucher[tab].voucherId &&
          state.promotions.appliedVoucher[tab].voucherId.toString() === id) {
          Vue.set(state.promotions.appliedVoucher, tab, {id: null, discount: 0, voucherId: null, isBetAvailable: false, betId: null, isActive: 0})
        }
      }
    }
  },
  clearAutoAppliedVoucher (state, bsTab) {
    // console.log('clearAutoAppliedVoucher')
    const clearAutoAppliedVoucherPerTab = (tab) => {
      // console.log('clearAutoAppliedVoucherPerTab:', tab)
      if (state.promotions.appliedVoucher[tab] &&
        state.promotions.appliedVoucher[tab].voucherId &&
        state.promotions.appliedVoucher[tab].isActive === -1) {
        Vue.set(state.promotions.appliedVoucher, tab, {id: null, discount: 0, voucherId: null, isBetAvailable: false, betId: null, isActive: 0})
      }
    }
    if (bsTab) {
      clearAutoAppliedVoucherPerTab(bsTab)
    } else {
      for (let tab in state.promotions.appliedVoucher) {
        clearAutoAppliedVoucherPerTab(tab)
      }
    }
  },
  deactivateVoucherOnDestroy (state, data) {
    // console.log('deactivateVoucherOnDestroy:', data, 'addingSelectionFromFastBetSlip:', state.addingSelectionFromFastBetSlip)
    if (state.addingSelectionFromFastBetSlip) {
      Vue.set(state, 'addingSelectionFromFastBetSlip', false)
      return
    }
    let tab = state.tab
    let voucherTab = data.betId.split('-')[0]
    if (tab === voucherTab && !state.currentBetSlipState) {
      let appliedVoucher = state.promotions.appliedVoucher[tab]
      if (appliedVoucher && appliedVoucher.betId === data.betId && appliedVoucher.voucherId === data.voucherId && appliedVoucher.isActive) {
        Vue.set(appliedVoucher, 'isActive', false)
      }
    }
  },
  reactivateVoucherDestroyed (state, data) {
    // console.log('reactivateVoucherDestroyed:', data, 'addingSelectionFromFastBetSlip:', state.addingSelectionFromFastBetSlip)
    if (state.addingSelectionFromFastBetSlip) {
      Vue.set(state, 'addingSelectionFromFastBetSlip', false)
      return
    }
    //
    let tab = state.tab
    let voucherTab = data.betId.split('-')[0]
    if (tab === voucherTab && !state.currentBetSlipState) {
      let appliedVoucher = state.promotions.appliedVoucher[tab]
      if (appliedVoucher && appliedVoucher.betId === data.betId && appliedVoucher.voucherId === data.voucherId && appliedVoucher.isActive === false) {
        Vue.set(appliedVoucher, 'isActive', true)
      }
    }
  },
  setAutoApply1stVoucherToBet (state, id) {
    // console.log('setAutoApply1stVoucherToBet')
    Vue.set(state.promotions, 'autoApply1stVoucherToBet', id)
  },
  setAddingSelectionFromFastBetSlip (state, bool) {
    Vue.set(state, 'addingSelectionFromFastBetSlip', bool)
  },
  addTeaserSelectionsData (state, selection) {
    // console.log('addTeaserSelectionsData:', selection)
    if (selection.teaserinfos) {
      Vue.set(selection, 'isTeaserSource', selection.isTeaserSource || 'T')
      // console.log('addTeaserSelectionsData:', selection)
      let id = selection.idfoselection
      let hcp = hcpFormat.getHandicap(selection)
      // Vue.set(state.teasers.teaserSelections, id.toString(), selection.teaserinfos)
      for (let ts of selection.teaserinfos) {
        let tsH = hcpFormat.getHandicap(ts) || 0
        let x = selection.hadvalue && ['A', 'O'].includes(selection.hadvalue) ? -1 : 1
        let spread = ts.spread ? ts.spread : (tsH - hcp) * x
        Vue.set(ts, 'spread', ts.spread || spread)
        Vue.set(ts, 'Spread', ts.spread)
        Vue.set(ts, 'idfoselectionsource', selection.idfoselection)
        Vue.set(ts, 'hadvalue', selection.hadvalue)
        Vue.set(ts, 'idfoevent', selection.idfoevent)
        Vue.set(ts, 'name', selection.name)
        Vue.set(ts, 'marketname', selection.marketname)
        Vue.set(ts, 'eventname', selection.eventname)
        Vue.set(ts, 'sportname', selection.sportname)
        Vue.set(ts, 'tsstart', selection.tsstart)
        Vue.set(ts, 'origin', selection.origin)
        //
        Vue.set(ts, 'pricetype', ts.pricetype || ts.pricetypecsv)
        if (ts.bettypecsv && typeof ts.bettypecsv === 'string') {
          Vue.set(ts, 'csvavailablebettypes', ts.bettypecsv.split(','))
        }
        //
        let hcpT = hcpFormat.getTeaserHcp(hcp, ts)
        Vue.set(ts, 'currenthandicap', ts.currenthandicap || hcpT)
        Vue.set(ts, 'currentmatchhandicap', ts.currentmatchhandicap || hcpT)
      }
      Vue.set(state.optedIn.TEASER, id, true)
      // console.log('addTeaserSelectionsData Final:', selection)
    } else {
      selection.teaserinfos = null
    }
  },
  setGUITeaserPriceTypes (state, val) {
    console.log('setGUITeaserPriceTypes:', val)
    if (val) {
      val = val.split(',')
      Vue.set(state.config.derivatives.teasers, 'guiTeaserPriceTypes', val)
    }
  },
  notifyUpdateBetSlipComplete (state) {
    // console.log('notifyUpdateBetSlipComplete')
    state.updateBetSlipComplete++
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslipV2/mutations.js